"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagAF = function FlagAF(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-56.47,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H-56.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "137.53",
    y: "1",
    width: "136.53",
    height: "268.36",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H80.07V-122H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M30.23,26H-6.63l2.05-4.1H28.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M30.23-6.74H-6.63l2.05,4.1H28.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22-4.69H1.56l4.1-4.1H17.94Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "189.41",
    y: "138.79",
    width: "6.15",
    height: "4.09",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "189.41",
    y: "132.64",
    width: "6.15",
    height: "4.09",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "189.41",
    y: "122.4",
    width: "6.15",
    height: "4.1",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "189.41",
    y: "128.55",
    width: "6.15",
    height: "2.05",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "216.04",
    y: "138.79",
    width: "6.15",
    height: "4.09",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "216.04",
    y: "132.64",
    width: "6.15",
    height: "4.09",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "216.04",
    y: "122.4",
    width: "6.15",
    height: "4.1",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "216.04",
    y: "128.55",
    width: "6.15",
    height: "2.05",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "191.46",
    y: "106.02",
    width: "4.09",
    height: "8.19",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.56-19h-4.1v-2A2,2,0,0,1-.49-23.12a2,2,0,0,1,2.05,2.05Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "216.04",
    y: "106.02",
    width: "4.1",
    height: "8.19",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.13-19H22v-2a2,2,0,0,1,2.05-2.05,2,2,0,0,1,2,2.05Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-.6A8.19,8.19,0,0,0,3.61,7.59V19.88H20V7.59A8.19,8.19,0,0,0,11.8-.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-1.76,12.3-12.91-.7a2.1,2.1,0,0,0,.14-.66,2,2,0,0,0-2.05-2,2,2,0,0,0-2.05,2.05,2,2,0,0,0,2.05,2,1.45,1.45,0,0,0,.35-.07L-13.32,2-18.92,15l6.15,6.14,5.3-12.37,4.16,4.85Zm-10,4.28-4.9-4.9,2.21-5.16,4.9,4.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27,13.64l4.16-4.85,5.31,12.37L42.57,15,37,2,38.12.61a2.17,2.17,0,0,0,.35.07,2,2,0,0,0,2.05-2,2,2,0,0,0-2.05-2,2,2,0,0,0-2,2.05,1.85,1.85,0,0,0,.13.66l-11.15,13Zm6.2-2.22,4.9-4.9,2.21,5.16-4.9,4.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.12-20.72a2.77,2.77,0,0,1-1.59-1.1,14.77,14.77,0,0,1-.73-1.3,14.68,14.68,0,0,1-.74,1.3,2.75,2.75,0,0,1-1.58,1.1,8.17,8.17,0,0,0-5.87,7.84,8,8,0,0,0,.29,2H19.7a8,8,0,0,0,.29-2,8.17,8.17,0,0,0-5.87-7.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-35.13,9.4c-.1-1.27-.17-2.55-.17-3.85a47.53,47.53,0,0,1,.66-7.76c.59.41,1.21.86,1.85,1.37a45,45,0,0,0-.46,6.39A44.55,44.55,0,0,0-33,10l4.33,1.29a40.73,40.73,0,0,1-.46-5.78c0-1,.06-1.95.14-2.91,2.26,2.5,4,5.53,4,8.88,0,.09,6.57-9.73-5.37-20.56l-.09,4.6-6.88-.07a1.28,1.28,0,0,0-1.27,1,51.7,51.7,0,0,0-.81,9c0,.87,0,1.73.07,2.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-17-31.74a2,2,0,0,0,.37-2.87A2,2,0,0,0-19.46-35,50.86,50.86,0,0,0-37.84-7l4.22.06A46.79,46.79,0,0,1-17-31.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-19.7-26.63A44.72,44.72,0,0,0-29.82-11.56a23.43,23.43,0,0,1,3.16,3.13,40.91,40.91,0,0,1,9.82-15.28,2,2,0,0,0,0-2.89,2,2,0,0,0-2.89,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-26.82,32.39a47,47,0,0,1-6.8-14.49l2.39.88A45,45,0,0,0-24.6,32l4.52-.83a41.61,41.61,0,0,1-6.19-10.55l2.68,1a39.22,39.22,0,0,0,5.8,9.15l4.7-.86a35.07,35.07,0,0,1-4.86-6.31l-2.72-5.44a6.8,6.8,0,0,0-4.14-3.49l-6.45-1.94-1.49-.44-2.15-.65-4.26-1.28-2.28-.69L-40,13.88a4.17,4.17,0,0,0,1.75,2.21,50.88,50.88,0,0,0,7,17.12Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54-4.44,54-9C42,1.79,48.57,11.61,48.57,11.52c0-3.35,1.79-6.38,4-8.88.08,1,.13,1.93.13,2.91a40.73,40.73,0,0,1-.45,5.78L56.62,10a44.55,44.55,0,0,0,.23-4.49,45,45,0,0,0-.46-6.39c.64-.51,1.25-1,1.84-1.37a46.45,46.45,0,0,1,.67,7.76c0,1.3-.07,2.58-.17,3.85l4.2-1.26c0-.86.06-1.72.06-2.59a51.7,51.7,0,0,0-.8-9,1.29,1.29,0,0,0-1.28-1Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M57.22-6.92l4.23,0A50.92,50.92,0,0,0,43.06-35a2,2,0,0,0-2.87.37,2,2,0,0,0,.37,2.87A46.79,46.79,0,0,1,57.22-6.92Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M53.42-11.56A45,45,0,0,0,43.3-26.63a2,2,0,0,0-2.89,0,2,2,0,0,0,0,2.89A40.91,40.91,0,0,1,50.26-8.43a22.85,22.85,0,0,1,3.16-3.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M62.77,10.33,58.5,11.61l-2.15.64-1.49.45-6.45,1.94a6.8,6.8,0,0,0-4.14,3.49l-2.72,5.44a35.43,35.43,0,0,1-4.86,6.31l4.7.86a39.22,39.22,0,0,0,5.8-9.15l2.67-1a41.17,41.17,0,0,1-6.18,10.56L48.2,32a45.24,45.24,0,0,0,6.64-13.22l2.38-.87a47,47,0,0,1-6.8,14.49l4.42.81a50.88,50.88,0,0,0,7-17.12,4.13,4.13,0,0,0,1.75-2.21L65,9.64Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.14,33l-.1.09a34.54,34.54,0,0,1-42.47,0L-9.54,33a3.26,3.26,0,0,0-3.06-1l-20.65,4.3,4.58,4a6,6,0,0,0,4.36,1.48A52,52,0,0,0-11.73,51l-1.34,2.48a52.17,52.17,0,0,0,49.74,0L35.33,51a52,52,0,0,0,12.58-9.22,6,6,0,0,0,4.36-1.48l4.58-4L36.2,32a3.26,3.26,0,0,0-3.06,1ZM-9.77,47.37a47.79,47.79,0,0,1-10.17-7.18l2-.95A45.23,45.23,0,0,0-8.8,45.57Zm53.31-7.18a47.79,47.79,0,0,1-10.17,7.18l-1-1.8a44.9,44.9,0,0,0,9.16-6.33ZM11.8,46.5a40.67,40.67,0,0,1-25.73-9.18l2-1a38.68,38.68,0,0,0,47.37,0l2,1A40.62,40.62,0,0,1,11.8,46.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-10.67,30.07c.88.74,1.79,1.44,2.74,2.1H31.53c.95-.66,1.86-1.36,2.74-2.1l-2-2h-41Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagAF;
exports["default"] = _default;